import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, map } from  'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { environment, API_SERVER_ADDRESS } from '../../environments/environment';
import { Usuario } from '../_models/usuario.model';
import { Parada } from '../_models/parada.model';


@Injectable({
	providedIn: 'root'
})
export class UserService {

	currentUser = new BehaviorSubject<Usuario | null>(null);

	constructor(
		private http: HttpClient,
		private storageService: StorageService
	)  {

	}

	getUserActivo(): Observable<Usuario> {
		return this.http.get(`${API_SERVER_ADDRESS}/v1/me`).pipe(
			map(res => res['usuario'])
		);
	}
	updateUser(usuario: Usuario): Observable<Usuario> {
		return this.http.put(`${API_SERVER_ADDRESS}/v1/usuarios`, usuario).pipe(
			map(results => results['usuario']),
			tap(async (updatedUser) => {
				if (updatedUser) {
					await this.storageService.set('usuario', updatedUser);
					this.currentUser.next(updatedUser);
				}
			})
		);
	}
	syncUserActivo() {
		return this.getUserActivo().pipe(
			tap(async (usuario) => {
				if (usuario) {
					await this.storageService.set('usuario', usuario);
					this.currentUser.next(usuario);
				}
			})
		);
	}
	updatePassword(user: Usuario) {
		return this.updateUser(user);
	}

	setUserActivo(user: Usuario): void {
		this.storageService.set('usuario', user);
		this.currentUser.next(user);
	}
	delUserActivo(): void {
		this.storageService.remove('usuario');
		this.currentUser.next(null);
	}

	puedeReservar(): { puede: boolean, motivo?: string } {
		const usuario = this.currentUser.getValue();

		// Si no está logueado
		if (!usuario) {
			return { puede: false, motivo: 'Debes estar logueado para reservar' };
		}

		// tieneq que estar logueado y con tarjeta declarada
		if (!usuario.tarjeta_tmg || usuario.tarjeta_tmg == '') {
			return { puede: false, motivo: 'Debes tener una tarjeta TMG válida para reservar' };
		}

		// El backend puede bloquear las reservas de un usuario (sistema anti-abuso)
		if (usuario.reservas_bloqueadas) {
			const motivo = usuario.reservas_bloqueadas_motivo || 'No puedes hacer reservas en este momento. Contacta con atención al cliente para más información.';
			return { puede: false, motivo };
		}

		return { puede: true };
	}


	getParadasFavoritas(): Promise<Parada[]> {
		return this.storageService.get('paradas');
	}
    deleteParadaFavorita(parada_id: number): Promise<Parada[]> {
		return this.storageService.get('paradas').then(paradas => {
			if (paradas) {
				const foundIndex = paradas.findIndex((p: Parada) => p.parada === parada_id);
				if (foundIndex !== -1) {
					paradas.splice(foundIndex, 1);
				}
				if (paradas.length == 0) {
					this.storageService.remove('paradas');
					return [];
				}
				this.storageService.set('paradas', paradas);
			}
			else {
				this.storageService.remove('paradas');
				return [];
			}
			return paradas;
		})
    }
    saveParadaFavorita(parada: Parada): Promise<Parada[]> {
		return this.storageService.get('paradas').then(paradas => {
			if (paradas) {
				const existe = paradas.some((p: Parada) => p.parada === parada.parada);
				if (!existe) {
					paradas.push(parada);
					this.storageService.set('paradas', paradas);
				}
				return paradas;
			}
			else {
				this.storageService.set('paradas', [parada]);
				return [parada];
			}
		})
	}
}